let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cvbLP")).then(() => parcelRequire('8j9DN'));